import React, { Component } from 'react';
import LoadableComponent from '../../common-components/PlaceholderLoading/LoadableComponent';
import ContentLoadPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/ContentLoadPlaceholder';
import ContentLoadErrorPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/ContentLoadErrorPlaceholder';
import { Translation } from "react-i18next";
import { LoadScript } from '../../types/LoadScript';
import { Configuration } from '../../types/Configuration';
import { ApiErrorEvent, ErrorEventType } from '../../common-components/Notifications/Events';

type Props = {
    configuration: Configuration
    accessToken: string,
    selectedLanguage: string,
    onLoadCallback: () => void,
    onErrorCallback: () => void,
    tokenIsProvided: boolean
}

type State = {
    scriptsToBeLoaded: [LoadScript, LoadScript]
    loadableComponent: any
    hasApiError: boolean;
}

class PersonalProfile extends Component<Props, State> {
    loadableComponentRef: React.RefObject<any>;
    constructor(props: Props) {
        super(props);
        this.state = {
            scriptsToBeLoaded: [ {} as LoadScript, {} as LoadScript ],
            loadableComponent: null,
            hasApiError: false
        };
        this.loadableComponentRef = React.createRef();
    }

    componentDidMount(){
        this.setState({
            scriptsToBeLoaded: [
                { url: `${this.props.configuration.profileWebComponentBaseUrl}/build/personal-profile-components.esm.js`, type: "module", nomodule: false },
                { url: `${this.props.configuration.profileWebComponentBaseUrl}/build/personal-profile-components.js`, type: "text/javascript", nomodule: true }
            ]
        })
        
        this._setEventListeners()
    }

    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.configuration
            && this.props.configuration
            && prevProps.configuration.profileWebComponentBaseUrl !== this.props.configuration.profileWebComponentBaseUrl
        ) {
            this.setState({
                scriptsToBeLoaded: [
                    { url: `${this.props.configuration.profileWebComponentBaseUrl}/build/personal-profile-components.esm.js`, type: "module", nomodule: false },
                    { url: `${this.props.configuration.profileWebComponentBaseUrl}/build/personal-profile-components.js`, type: "text/javascript", nomodule: true }
                ]
            })
        }
    }

    _setEventListeners() {
        document.addEventListener('apiErrorEvent', ((event: CustomEvent<ApiErrorEvent>) => {
            if (event.detail.errorType === ErrorEventType.FatalError && event.detail.webComponentName === 'my-account-personal-profile') {
                this.setState({hasApiError: true})
                this.loadableComponentRef.current.handleOutsideApiError();
            }
        }) as EventListener);
    }

    render() {
        const message = <Translation>{t => t(`Unfortunately we could not load "General".`)}</Translation>;
        return (
            <LoadableComponent
                loadPlaceholder={ContentLoadPlaceholder}
                errorPlaceholder={ContentLoadErrorPlaceholder}
                scriptsToBeLoaded={this.state.scriptsToBeLoaded}
                message={message}
                hasOutsideApiError={this.state.hasApiError}
                ref={this.loadableComponentRef}
                {... this.props}>
                <personal-profile
                    token-is-provided={this.props.tokenIsProvided}
                    base-url={this.props.configuration.profileWebComponentBaseUrl}
                    language={this.props.selectedLanguage}
                    url={this.props.configuration.profileComponentApiUrl}>
                </personal-profile>
            </LoadableComponent>
        )
    }
}

export default PersonalProfile;